import { unstable_batchedUpdates } from 'react-dom'

import { registerMissingCompanyLogoImage } from '../SitemapHelpers/utils/GLCompanyLogoImageRegistrar'
import {
  MARKER_KEY_PREFIX,
  renderMissingMarkerImage,
} from '../SitemapHelpers/utils/GLMarkerImageGenerator'
import { registerMissingSharedChipImage } from '../SitemapHelpers/utils/GLSharedChipImage'
import {
  registerMissingWorkflowPinImage,
  WORKFLOW_PIN_KEY_PREFIX,
} from '../SitemapHelpers/utils/GLWorkflowPinImageGenerator'
import { rasterRatio } from '../SitemapHelpers/utils/iconGeometry'

// How many times their own size a map draws the Workflow pins and the Location icons, so their
// images are rasterized that sharp.
export interface IMapImageDensity {
  pin: number
  marker: number
}

const OWN_SIZE: IMapImageDensity = { pin: 1, marker: 1 }

export function registerMissingMapImage(
  map: mapboxgl.Map,
  id: string,
  density: IMapImageDensity = OWN_SIZE,
): void {
  renderMissingMarkerImage(map, id, density.marker)
  registerMissingWorkflowPinImage(map, id, density.pin)
  registerMissingCompanyLogoImage(map, id)
  registerMissingSharedChipImage(map, id)
}

// The pins and Location icons already on the map, rasterized again at a new density: only the kinds
// whose raster ratio it changes. Each is removed and added back in the same task, so no frame draws
// its symbol without an image. Every add and remove fires styledata, which each react-map-gl source
// and layer answers with a render of its own; batched, React renders them once.
export function rerasterMapImages(
  map: mapboxgl.Map,
  density: IMapImageDensity,
  from: IMapImageDensity = OWN_SIZE,
): void {
  const prefixes = [
    rasterRatio(density.marker) !== rasterRatio(from.marker) &&
      MARKER_KEY_PREFIX,
    rasterRatio(density.pin) !== rasterRatio(from.pin) &&
      WORKFLOW_PIN_KEY_PREFIX,
  ].filter(Boolean)
  if (!prefixes.length) return
  unstable_batchedUpdates(() =>
    map
      .listImages()
      .filter(id => prefixes.some(prefix => id.startsWith(prefix)))
      .forEach(id => {
        map.removeImage(id)
        registerMissingMapImage(map, id, density)
      }),
  )
}
